import React, { useContext } from "react";
import "./ProcessStatusModal.scss";
import { AiIcon } from "../../../VectorIcons/AiIcon";
import { Box, Button, Typography } from "@mui/material";
import { RecommendationsAPIContext } from "../../../../context/RecommendationsAPI/recommendationsAPIContext";
import SimpleScriptBox from "../../../../views/ProjectSheet/SimpleScriptBox/SimpleScriptBox";
import { ProcessStatusLoading } from "../../Loadings/ProcessStatusLoading/ProcessStatusLoading";
import { RECOMMENDATION_API_CONSTANTS } from "../../../../context/RecommendationsAPI/constants";

export function ProcessStatusModal({
  open,
  title,
  handleClose,
  handleOnComplete,
}) {
  const { processData } = useContext(RecommendationsAPIContext);

  const textColor = (() => {
    if (
      processData?.status === RECOMMENDATION_API_CONSTANTS.TASK_STATUS_PENDING
    )
      return "#B03EFA";

    if (
      processData?.status === RECOMMENDATION_API_CONSTANTS.TASK_STATUS_COMPLETE
    )
      return "#B03EFA";

    if (processData?.status === RECOMMENDATION_API_CONSTANTS.TASK_STATUS_FAILED)
      return "#EC1045";

    return "#000000";
  })();

  return (
    <SimpleScriptBox
      open={open}
      title={title}
      icon={<AiIcon color="#FFF" />}
      className="process-status-modal"
      size="large"
      removePadding={true}
      allowOverflow={true}
      toggleScriptBox={handleClose}
    >
      <Box sx={{ backgroundColor: "#FFF", padding: "42px 100px 24px 100px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "16px",
          }}
        >
          <Typography
            sx={{
              color: textColor,
              fontSize: "16px",
              fontWeight: 900,
              fontFamily: "inherit",
              textAlign: "center",
              marginRight: "16px",
            }}
          >
            <>
              {processData?.status ===
                RECOMMENDATION_API_CONSTANTS.TASK_STATUS_PENDING &&
                "Lendo arquivo"}

              {processData?.status ===
                RECOMMENDATION_API_CONSTANTS.TASK_STATUS_FAILED && "Atenção"}

              {processData?.status ===
                RECOMMENDATION_API_CONSTANTS.TASK_STATUS_COMPLETE &&
                "Leitura completa"}
            </>
          </Typography>

          {processData?.status ===
            RECOMMENDATION_API_CONSTANTS.TASK_STATUS_PENDING && (
            <ProcessStatusLoading />
          )}
        </Box>

        <Typography
          sx={{
            color: "#A9AAB8",
            fontSize: "12px",
            fontFamily: "inherit",
            textAlign: "center",
            marginBottom: "24px",
          }}
        >
          {`${processData?.data?.fileName}`}
        </Typography>

        <Typography
          sx={{
            fontFamily: "inherit",
            fontSize: "16px",
            textAlign: "left",
          }}
        >
          {processData?.status ===
            RECOMMENDATION_API_CONSTANTS.TASK_STATUS_PENDING &&
            `A leitura do arquivo pode demorar um pouco, você pode fechar essa tela que avisaremos quando tudo estiver pronto.`}

          {processData?.status ===
            RECOMMENDATION_API_CONSTANTS.TASK_STATUS_FAILED && (
            <>
              <Typography
                sx={{
                  fontFamily: "inherit",
                  fontSize: "16px",
                  textAlign: "left",
                  marginBottom: "16px",
                }}
              >
                Não foi possível ler o arquivo selecionado. Verifique-o e tente
                novamente.
              </Typography>

              <Typography
                sx={{
                  fontFamily: "inherit",
                  fontSize: "16px",
                  textAlign: "left",
                }}
              >
                {`Caso o problema persista, entre em contato com suporte e reporte
                o código: `}
                <span
                  style={{ color: "#7F808E" }}
                >{`${processData?.xCorrelationId}`}</span>
              </Typography>
            </>
          )}
        </Typography>

        {processData?.status ===
          RECOMMENDATION_API_CONSTANTS.TASK_STATUS_COMPLETE && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "16px",
            }}
          >
            <Typography
              sx={{
                fontFamily: "inherit",
                fontSize: "16px",
                textAlign: "left",
                marginRight: "36px",
              }}
            >
              A leitura do arquivo foi concluída, clique no botão ao lado para
              ver o resultado.
            </Typography>

            <Button
              onClick={handleOnComplete}
              disabled={false}
              sx={{
                alignItems: "center",
                padding: "8px 24px",
                borderRadius: "4px",
                backgroundColor: "#B03EFA",
                color: "#FFF",
                fontSize: "16px",
                textTransform: "none",
                transition: "all 200ms ease-in-out",
                minWidth: "160px",
                fontFamily: "inherit",
                fontWeight: 700,
                marginLeft: "auto",
                whiteSpace: "nowrap",

                "&:hover": {
                  backgroundColor: "rgba(179, 102, 255, 0.3)",
                  borderColor: "#9B4FD6",
                },

                "&:active": {
                  backgroundColor: "rgba(179, 102, 255, 0.15)",
                },

                "&:disabled": {
                  opacity: 0.5,
                  cursor: "not-allowed",
                },

                "&:focus-visible": {
                  outline: "none",
                  boxShadow: "0 0 0 4px rgba(179, 102, 255, 0.18)",
                },
              }}
            >
              Abrir resultado
            </Button>
          </Box>
        )}
      </Box>
    </SimpleScriptBox>
  );
}
